import {
  CashAccountType,
  InvestmentType,
  LoanType,
  MappedEntityType,
  PlaidItemAccountMapping,
} from '../../../generated/graphql';
import { displayMonetaryAmount } from '../../../util';
import { IconButton, SectionHeader } from '../../index';
import { displayMappedAccountType } from '../../../Plaid/util';

interface PlaidAccountItemProps {
  accounts: PlaidItemAccountMapping[];
  type: CashAccountType | InvestmentType | LoanType;
  mappedType: MappedEntityType;
  handleItemEdit: (item: PlaidItemAccountMapping) => void;
}

export const PlaidAccountItem = ({ accounts, type, mappedType, handleItemEdit }: PlaidAccountItemProps) => {
  return (
    <>
      <SectionHeader header={displayMappedAccountType(type, mappedType)} className="mt-4" />
      <div className="pr-3 sm:pr-0">
        {accounts.map((item) => {
          return (
            <div
              className="flex justify-between relative odd:bg-darkMode-gray-medium/10 even:bg-darkMode-gray-medium/[.05] first:rounded-t-2xl last:rounded-b-2xl"
              key={item.plaidItemID}
            >
              <div className="flex justify-between items-center p-4 w-full">
                <div>
                  <h4 className="font-medium">{item.name}</h4>
                  <p className="font-normal text-darkMode-gray-medium text-sm">
                    *****{item.mask} | {item.officialName}
                  </p>
                </div>
                <h2 className="font-bold text-[18px]">{displayMonetaryAmount(item.balance)}</h2>
              </div>
              <IconButton
                icon="pencil"
                className="absolute right-[-40px] top-4 bg-transparent"
                theme="secondary"
                onClick={() => handleItemEdit(item)}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};
